<div class="overlayContainer d-none" *ngIf="damage.bestImageUrl.mini || damage.roiPtr.imagePtr" #thumbnail>
    <img class="thumbnailDamage" [src]="damage.imageOverlay" alt="thumbnail" *ngIf="damage.imageOverlay" />
    <img class="thumbnail" [src]="damage.roiPtr.imagePtr ? damage.roiPtr.imagePtr.file.url() :damage.bestImageUrl.mini"
        alt="thumbnail" crossorigin="anonymous" (load)="thumbnail.classList.remove('d-none')" />
    <div class="overlay ">
        <div class="row h-100">
            <div class="col-6 m-0 p-0 my-auto">
                <img *ngIf="damage.roiPtr.imagePtr === undefined" class="svgicon"
                    src="../../../assets/icon/fullscreen_btn.svg"
                    [routerLink]="['/player', damage?.tchekPtr?.id , damage?.roiPtr?.folderPtr?.name, _roiService.toPicturePercent(damage?.roiPtr?.picture, damage?.roiPtr?.folderPtr?.totalPictures)]" />
                <img *ngIf="damage.roiPtr.imagePtr !== undefined" class="svgicon"
                    src="../../../assets/icon/fullscreen_btn.svg"
                    [routerLink]="['/viewer', damage?.tchekPtr?.id , damage.roiPtr.imagePtr.id]" />
            </div>
            <div class="col-6 m-0 p-0 my-auto">
                <a *ngIf="!spinner" download="immat-{{damage?.tchekPtr?.vehiclePtr?.immat}}-dommage-{{damage?.uid}}"
                    (click)="downloadImage()">
                    <img class="svgicon" src="../../../assets/icon/download_btn.svg" />
                </a>
                <div *ngIf="spinner">
                    <img class="spinner" src="../../../assets/images/spinner.gif" />
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/thumbnail-damage/thumbnail-damage.component.html